import { ShieldAlert } from "lucide-react";

export function NoSubscriptionScreen() {
  return (
    <div className="mb-4 p-6 bg-yellow-500/10 border border-yellow-500/30 rounded-xl text-center">
      <div className="mx-auto w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center mb-3">
        <ShieldAlert className="w-6 h-6 text-yellow-400" />
      </div>
      <h2 className="text-lg font-semibold text-white mb-1">
        Aucun forfait actif
      </h2>
      <p className="text-sm text-white/60">
        Vous devez avoir un forfait actif pour utiliser le chat. Veuillez contacter votre administrateur pour commencer.
      </p>
    </div>
  );
}
